import React, { Component } from "react";
import { Link } from "react-router-dom";
import catGif from "../assets/cat_gif.gif";

import UserService from "../services/user.service";
import AuthService from "../services/auth.service";

export default class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: "",
      currentUser: null
    };
  }

  componentDidMount() {
    const currentUser = AuthService.getCurrentUser();
    this.setState({ currentUser: currentUser });

    UserService.getPublicContent().then(
      response => {
        this.setState({
          content: response.data
        });
      },
      error => {
        this.setState({
          content:
            (error.response && error.response.data) ||
            error.message ||
            error.toString()
        });
      }
    );
  }

  render() {
    const { currentUser } = this.state;
    
    return (
      <div className="container">
        <header className="jumbotron">
          <h3>{this.state.content}</h3>
        </header>
        {currentUser && (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '20px', gap: '15px' }}>
            <Link to="/add-expense" className="btn btn-primary btn-lg">
              Add Expense
            </Link>
            <Link to="/grocery-organizer" className="btn btn-primary btn-lg">
              Grocery Organizer
            </Link>
          </div>
        )}
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src={catGif} alt="cat gif" />
        </div>
      </div>
    );
  }
}
